import Modal from "views/components/UI/Modal";
import {
    Button,
    ButtonBack,
    ButtonContainer,
    Container,
    SubTitle,
    SubTitleContainer,
    Title,
} from "../Users/finish-process-modal/styled";

interface IModalConfirmDeleteEditedRoleFamily {
    visible: boolean;
    onAccept: () => void;
    onCancel: () => void;
}

const ModalConfirmDeleteEditedRoleFamily = (props: IModalConfirmDeleteEditedRoleFamily) => {
    const { visible, onAccept, onCancel } = props;

    return (
        <Modal
            show={visible}
            setShow={() => {}}
            styleContent={{ width: '440px', padding: '28px 24px 20px' }}
            hideCloseButton
        >
            <Container style={{ gap: '24px' }}>
                <SubTitleContainer style={{ height: 'auto' }}>
                    <div style={{ width: '100%' }}>
                        <Title>¿Estás seguro de que deseas retroceder?</Title>
                        <SubTitle style={{ marginTop: '12px' }}>
                            Si retrocedes ahora, perderás los cambios realizados en la familia de rol.
                        </SubTitle>
                    </div>
                </SubTitleContainer>
                <ButtonContainer style={{ justifyContent: 'flex-end', gap: '12px' }}>
                    <ButtonBack onClick={onCancel}>Cancelar</ButtonBack>
                    <Button onClick={onAccept}>Sí, retroceder</Button>
                </ButtonContainer>
            </Container>
        </Modal>
    )
}

export default ModalConfirmDeleteEditedRoleFamily;
